var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ProductSpecialRestrictionCode, } from '@millerknoll/pub-api-schema';
import { ADD_MODE_PRERELEASE_COMMENT } from 'utils/cpa-utils';
import { apiService } from './api-service';
function getProduct(cpn, importProduct, signal) {
    return __awaiter(this, void 0, Promise, function () {
        var rsp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiService.get("cpa/product/".concat(cpn, "?importProduct=").concat(importProduct || false), signal)];
                case 1:
                    rsp = _a.sent();
                    return [2 /*return*/, {
                            status: rsp.status,
                            body: rsp.body,
                        }];
            }
        });
    });
}
function createProduct(cpn, product) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var rsp;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (product.restrictions) {
                        if (((_a = product.restrictions[ProductSpecialRestrictionCode.PRERELEASE]) === null || _a === void 0 ? void 0 : _a.isActive) === true) {
                            product.restrictions[ProductSpecialRestrictionCode.PRERELEASE] = __assign(__assign({}, product.restrictions[ProductSpecialRestrictionCode.PRERELEASE]), { comment: (_b = product.restrictions[ProductSpecialRestrictionCode.PRERELEASE].comment) !== null && _b !== void 0 ? _b : ADD_MODE_PRERELEASE_COMMENT });
                        }
                    }
                    return [4 /*yield*/, apiService.post("cpa/product/".concat(cpn), product)];
                case 1:
                    rsp = _c.sent();
                    return [2 /*return*/, {
                            status: rsp.status,
                            body: rsp.body,
                        }];
            }
        });
    });
}
function generateCpn(customPrefixType) {
    return __awaiter(this, void 0, Promise, function () {
        var rsp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiService.get("cpa/cpn/".concat(customPrefixType))];
                case 1:
                    rsp = _a.sent();
                    return [2 /*return*/, {
                            status: rsp.status,
                            body: rsp.body,
                        }];
            }
        });
    });
}
function updateProduct(cpn, product) {
    return __awaiter(this, void 0, Promise, function () {
        var rsp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiService.put("cpa/product/".concat(cpn), product)];
                case 1:
                    rsp = _a.sent();
                    return [2 /*return*/, {
                            status: rsp.status,
                            body: rsp.body,
                        }];
            }
        });
    });
}
function getAudits(cpn) {
    return __awaiter(this, void 0, Promise, function () {
        var rsp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiService.get("cpa/audit/".concat(cpn))];
                case 1:
                    rsp = _a.sent();
                    return [2 /*return*/, { status: rsp.status, body: rsp.body }];
            }
        });
    });
}
function getPricing(cpn) {
    return __awaiter(this, void 0, Promise, function () {
        var rsp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiService.get("cpa/price/".concat(cpn))];
                case 1:
                    rsp = _a.sent();
                    return [2 /*return*/, { status: rsp.status, body: rsp.body }];
            }
        });
    });
}
function createPrice(priceRequest) {
    return __awaiter(this, void 0, void 0, function () {
        var rsp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiService.post("cpa/price", priceRequest)];
                case 1:
                    rsp = _a.sent();
                    return [2 /*return*/, { status: rsp.status, body: rsp.body }];
            }
        });
    });
}
function updatePrice(priceRequest) {
    return __awaiter(this, void 0, void 0, function () {
        var rsp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiService.put("cpa/price", priceRequest)];
                case 1:
                    rsp = _a.sent();
                    return [2 /*return*/, { status: rsp.status, body: rsp.body }];
            }
        });
    });
}
function deletePrice(cpn, startDate, workflow) {
    return __awaiter(this, void 0, void 0, function () {
        var rsp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiService.delete("cpa/price?cpn=".concat(cpn, "&startDate=").concat(startDate, "&workflow=").concat(encodeURIComponent(workflow)))];
                case 1:
                    rsp = _a.sent();
                    return [2 /*return*/, { status: rsp.status, body: rsp.body }];
            }
        });
    });
}
var cpaService = {
    getProduct: getProduct,
    createProduct: createProduct,
    updateProduct: updateProduct,
    generateCpn: generateCpn,
    getAudits: getAudits,
    getPricing: getPricing,
    createPrice: createPrice,
    updatePrice: updatePrice,
    deletePrice: deletePrice,
};
export { cpaService };
